/* unplugin-vue-components disabled */import { render } from "./wangeditor.vue?vue&type=template&id=f6e04602"
import script from "./wangeditor.vue?vue&type=script&lang=js"
export * from "./wangeditor.vue?vue&type=script&lang=js"

import "./wangeditor.vue?vue&type=style&index=0&id=f6e04602&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__